import { NgModule } from '@angular/core';
import { MatExpansionModule } from '@angular/material/expansion';
import { MatIconModule } from '@angular/material/icon';
import { MatTooltipModule } from '@angular/material/tooltip';
import { MatButtonModule } from '@angular/material/button';
import { MatDividerModule } from '@angular/material/divider';
import { MatMenuModule } from '@angular/material/menu';
import { MatSlideToggleModule } from '@angular/material/slide-toggle';
import { OfferOptionComponent } from './offer-option/offer-option.component';
import { OfferOptionEditDialogComponent } from './offer-option-edit-modal/offer-option-edit-dialog.component';
import { OfferOptionPublishDialogComponent } from './offer-option-publish-modal/offer-option-publish-dialog.component';
import { OfferOptionMoreMenuComponent } from './offer-option-more-menu/offer-option-more-menu.component';
import { OfferOptionSnackBarDataComponent } from './offer-option-snack-bar-data/offer-option-snack-bar-data.component';
import { ApprovalModule } from 'app/approval/approval.module';
import { CommonModule } from '@angular/common';
import { RestrictedRadioModule } from 'app/components/restricted-radio/restricted-radio.module';
import { RestrictedSliderModule } from 'app/components/restricted-slider/restricted-slider.module';
import { RestrictedInputModule } from 'app/components/restricted-input/restricted-input.module';
import { DiscreteSliderModule } from 'app/components/discrete-slider/discrete-slider.module';
import { RouterModule } from '@angular/router';
import { MatDialogModule } from '@angular/material/dialog';

@NgModule({
  declarations: [
    OfferOptionComponent,
    OfferOptionEditDialogComponent,
    OfferOptionPublishDialogComponent,
    OfferOptionMoreMenuComponent,
    OfferOptionSnackBarDataComponent
], imports: [
        MatExpansionModule,
        MatIconModule,
        MatTooltipModule,
        MatButtonModule,
        MatDividerModule,
        MatMenuModule,
        MatSlideToggleModule,
        CommonModule,
        RestrictedRadioModule,
        RestrictedSliderModule,
        RestrictedInputModule,
        DiscreteSliderModule,
        RouterModule,
        ApprovalModule,
        MatDialogModule,
    ],
  exports: [OfferOptionComponent, OfferOptionMoreMenuComponent, OfferOptionEditDialogComponent, OfferOptionPublishDialogComponent],
})
export class OfferOptionModule {}
